import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { CrudStoreItemScout } from 'legacy/lut/classes/models/CrudStoreItemScout'
import { PhoneCall } from 'legacy/lut/components/shared/PhoneCall'
import React from 'react'

import { Button } from 'core-components/library/button'
import { stylesTable } from 'core-components/library/list'
import { IFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

import { ICellProps } from './models'

export function Cell({ item, column, cellAttrs, onSelect, canSelectRule }: ICellProps) {
  let content = <></>

  switch (column.field) {
    case 'PartnerID':
      content = (
        <b
          onClick={(e) => {
            onRowSelect(item.get('PartnerID'))
            e.stopPropagation()
          }}
        >
          {item.get('PartnerID')}
        </b>
      )
      break
    case 'MainPhone':
      if ((item.get('MainPhone') || '').length) {
        content = (
          <PhoneCall
            value={`${item.get('MainPhoneCountryCode') || ''}${item.get('MainPhone') || ''}`}
            guid={item.get('HPD_Partner_GUID')}
            onClick={(e: any) => {
              e.stopPropagation()
            }}
            partnerId={item.get('PartnerID')}
          />
        )
      }
      break
    case 'SelectPartner':
      if (onSelect) {
        const canSelect = !canSelectRule || canSelectRule(item)
        content = (
          <span
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
            }}
          >
            <Button
              disabled={!canSelect}
              onClick={() => {
                onSelect(item)
              }}
            >
              {' '}
              Select{' '}
            </Button>
          </span>
        )
      }
      break
    default:
      content = item.get(column.field)
  }

  return (
    <td
      {...cellAttrs}
      key={`${item.get('PartnerID')}-${column.field}`}
      className={stylesTable.cell}
    >
      {content}
    </td>
  )
}

const onRowSelect = (pid: string) => {
  const contacts = CrudStore.get(CrudStoreItem.ContactAllData, 'contact-list')
  const filters = contacts.getFilter() || {
    logic: Logic.AND,
    filters: [],
  }
  if (!filters.filters) {
    filters.filters = []
  }
  const findedContact = filters.filters.find((f) => (f as IFilter).field === 'PartnerID')
  if (findedContact) {
    const element = findedContact as IFilter
    element.value = pid
  } else {
    filters.filters.push({
      field: 'PartnerID',
      operator: Operator.EQUAL,
      value: pid,
    })
  }
  contacts.setFilter({ ...filters })

  const contracts = CrudStore.get(CrudStoreItemScout.WW_PartnerFlags, 'contracts-list')
  const contractsFilter = contracts.getFilter() || {
    logic: Logic.AND,
    filters: [],
  }
  if (!contractsFilter.filters) {
    contractsFilter.filters = []
  }
  const findedContract = contractsFilter.filters.find((f) => (f as IFilter).field === 'PARTNER_ID')
  if (findedContract) {
    const element = findedContract as IFilter
    element.value = pid
  } else {
    contractsFilter.filters.push({
      field: 'PARTNER_ID',
      operator: Operator.EQUAL,
      value: pid,
    })
  }

  contracts.setFilter({ ...contractsFilter })
}
